export default "__VITE_ASSET__DPDNssg5__"